import { Component, EventEmitter, Input, Output, inject } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { ColumnConfig } from '../table.component'
import { MatDialog } from '@angular/material/dialog'
import { CommentDialogComponent } from 'src/components/common/comment-dialog/comment-dialog.component'

@Component({
  selector: 'app-table-cell',
  templateUrl: './table-cell.component.html'
})
export class TableCellComponent<T> {
  @Input() column: ColumnConfig<any>
  @Input() element: any

  @Output() cellClick = new EventEmitter<{ column: string; element: T; action: string, context?: string }>()

  readonly dialog = inject(MatDialog)
  currentRow: T
  currentAction: string

  constructor(private sanitizer: DomSanitizer) {}

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html)
  }

  handleHtmlClick(event: Event, column: string, element: T) {
    let target = event.target as HTMLElement
    const action = target?.getAttribute('data-action')
    const context = target?.getAttribute('data-context');
    this.handleCellClick(column, element, action, context)
  }

  handleCellClick(column: string, element: T, action: string, context: string) {
    this.cellClick.emit({ column, element, action, context })
  }

  getActionsForElement(element: any) {
    return this.column.actions.filter(action => !action.condition || action.condition(element))
  }

  handleActionClick(action: string, element: T) {
    this.currentRow = element
    this.currentAction = action
    if (action != 'showPaymentHistoryAction') {
      this.openCommentDialog(action)
    } else {
      this.cellClick.emit({ column: 'actions', element, action })
    }
  }

  openCommentDialog(action: string): void {
    const dialogRef = this.dialog.open(CommentDialogComponent, { width: '400px', data: { ...this.currentRow, action: action }})
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.currentRow = { ...this.currentRow, statusUpdateInfo: result }
        this.cellClick.emit({ column: 'actions', element: this.currentRow, action: this.currentAction })
      }
    })
  }
}
